import { render, staticRenderFns } from "./AddTravelFormModal.vue?vue&type=template&id=56abda83&"
import script from "./AddTravelFormModal.vue?vue&type=script&lang=js&"
export * from "./AddTravelFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports